<div id="abilitySurveyWrap" [ngClass]="{'none':!judgeFinish}" >

	<div class="common-back-btn-sight" (click)="close()" style="z-index: 99;" *ngIf="isOpenClass==0">
	    <span>×</span>
	 </div>
	<div class="header" *ngIf="showIntroduce">
		<div class="title">{{title}}</div>
	</div>
	<div class="header" [ngClass]="{'z0':!showsceneBtnEnable}" *ngIf="!showIntroduce" style="background: transparent;">
		<app-countdown *ngIf="isDataLoad" [totalSeconds]="remainTime" [remindSeconds]="60" (onTimeout)="onTimeout(true)" (onTimeReminder)="onTimeReminder(true)"></app-countdown>
		<div class="btn-simulation"  *ngIf="currentSceneTip"  (click)="showSceneDialog()">情景描述{{currentSceneTip.index + 1}}</div>
	</div>

	<ul id="questionItem">
		<li class="current finish" *ngIf="showIntroduce && oldGuidePage" style="transition: top .3s linear;">
			<div class="introduce">
				<!--<div class="subtitle"><i class="icon-theory"></i> 理论背景</div>-->
        <p>
          <span *ngIf="typeId == 1"><b>理论背景:</b></span>
          <span *ngIf="typeId == 1">
          测验通过情景判断测验技术，基于DDI的能力模型，对领导力的关键行动（Key Action)进行测量。提供有针对性的学习建议以帮助你实现能力的提升。
          </span>
          <span *ngIf="typeId == 2"><b>测评目的:</b></span>
          <span *ngIf="typeId == 2">
            测验能够帮助你诊断学后的能力现状，和学前的测验结果对比以评估学习效果，并帮助你了解自身表现出色和有待提高的方面。
          </span>
        </p>

				<!--<div class="subtitle"><i class="icon-content"></i> 测评内容</div>-->
				<p *ngIf="typeId == 1">
          <span><b>测评内容:</b></span>
          本测验通过让你判断工作情景下各行为选项的有效性，以此衡量你的能力水平。
				</p>

				<div class="introduce-bottom">
          <div class="title"><i class="icon-tip"></i><span class="clr7297E6"><b>温馨提醒</b></span></div>
          <div class="introduce-bottom-content" *ngIf="typeId==1">
            <div>1.测验<b>只有一次机会，限时<span class="clr7297E6">25</span>分钟，</b>请尽量保证不被打扰；</div>
            <br />
            <div>2.如果发生<b>中途接电话等突发事件，建议退出测验下次继续，</b>不然可能会因为接电话时间长导致时间不够影响结果。</div>
          </div>
          <div class="introduce-bottom-content" *ngIf="typeId==2">
            <div>1.<b>测验仅有一次机会！</b>做测验之前，自己是否信心满满。准备充分再来挑战！</div>
            <br />
            <div>2.不要急，时间充足，<b>有25分钟时间</b>，审题不认真会导致结果不理想。</div>
            <br />
            <div>3.在<b>安静、不被打扰</b>的环境下完成，结果会更好。</div>
          </div>
				</div>
			</div>
    </li>
    <li class="current finish" *ngIf="showIntroduce && !oldGuidePage" style="transition: top .3s linear;">
      <div class="card-container">
        <div class="center-section">
          <!-- 前测 -->
          <ng-container *ngIf="typeId == 1">
            <div class="desc">
              优秀的领导者，不仅要识人，更需要<span class="highlight">知己</span>。
            </div>
            <div class="question">
              你的 <span class="highlight">{{ abilityName }}</span> 在哪个等级？
            </div>
            <img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/picture1.png" alt="">
          </ng-container>
          <!--  后测-->
          <ng-container *ngIf="typeId == 2">
            <div class="desc">
              了解变化，才有提升的可能。
            </div>
            <div class="question">
              想了解你的能力变化吗？
            </div>
            <img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/picture2.png" alt="">
          </ng-container>
        </div>
        <div class="tips" *ngIf="typeId == 1">
          <h3 class="title">温馨提醒：</h3>
          <ul class="tip-list">
            <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip1_icon.png" alt=""><span>领导力精要是团队领导力的基础，学前检测是为了了解你目前的水平</span></li>
            <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip2_icon.png" alt=""><span>以下检测需要花费约<span class="highlight">5</span>分钟完成</span></li>
            <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip3_icon.png" alt=""><span>检测只能做<span class="highlight">1</span>次，请认真对待哦！</span></li>
          </ul>
		</div>
        <div class="tips" *ngIf="typeId == 2">
			<h3 class="title">温馨提醒：</h3>
			<ul class="tip-list">
			  <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip1_icon.png" alt="">领导力精要是团队领导力的基础，阶段考核是为了检验你学习后的水平</li>
			  <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip2_icon.png" alt="">以下检测需要花费约<span class="highlight">5</span> 分钟完成 </li>
			  <li><img class="picture" src="{{assetsRoute}}/picture/abilitysurvey/tip3_icon.png" alt="">检测只能做<span class="highlight">1</span>次，请认真对待哦</li>
			</ul>
		  </div>
      </div>
    </li>
		<li *ngFor="let item of questionsList;let i= index;" [ngClass]="{'finish':item.completeFlag,'showeffective':item.showEffective,'showinvalid':item.showInvalid,'questionItem':item.type == 'question'}">
			<div *ngIf="item.type == 'scene'" [ngClass]=" 'scene scene' + item.sceneId " >
				<div class="sceneInner">
					<div class="sceneSimpleTitle">情景{{item.sceneIndex+1}}</div>
          <p [innerHtml]="item.sceneTitle"></p>
          <p [innerHtml]="item.sceneDesc"></p>
<!--					<div class="sceneTitle">{{item.sceneTitle}}</div>-->
<!--					<div class="sceneDes"  [innerHtml]="item.sceneDesc"></div>-->
          <div class="pc-btn" *ngIf="isPC" style="position: absolute;left: 50%;bottom: .2rem;transform: translateX(-50%);" (click)="doExercises()">下一步</div>
				</div>
			</div>

			<div *ngIf="item.type == 'question'" class="question-info">
				<input type="hidden" class="simulationIndex" value="{{item.sceneIndex}}" />
				<div><span class="bold">({{item.qstIndex}}/{{qstCount}})</span>&nbsp;{{item.questionsName}} 请分别选出<span class="clr-effective">最有效</span>和<span class="clr-invalid">最无效</span>的措施。</div>
				<div class="option">
					<div class="option-item" *ngFor="let subItem of item.surveySceneOptions;">
						{{subItem.optionsName}}
					</div>
				</div>
				<div class="answer">
					<div class="btn-effective" (click)="showEffective(item);" [ngClass]="{'on': item.effectiveOptionsNo != 0 }">
						<p class="fs36">最有效措施</p>
						<p class="fs28" *ngIf="item.effectiveOptionsNo == 0">点击此处选择</p>
						<p class="fs28" *ngIf="item.effectiveOptionsNo != 0">已经选择:
							<span  *ngFor="let subItem2 of item.surveySceneOptions;let z=index;" >
								<span *ngIf=" subItem2.optionsNo == item.effectiveOptionsNo ">{{letterList[z]}}</span>
							</span>
						</p>
					</div>
					<div class="btn-invalid" (click)="showInvalid(item);" [ngClass]="{'on': item.invalidOptionsNo != 0 }">
						<p class="fs36">最无效措施</p>
						<p class="fs28" *ngIf="item.invalidOptionsNo == 0">点击此处选择</p>
						<p class="fs28" *ngIf="item.invalidOptionsNo != 0">已经选择:
							<span *ngFor="let subItem2 of item.surveySceneOptions;let z=index;" >
								<span *ngIf=" subItem2.optionsNo == item.invalidOptionsNo ">{{letterList[z]}}</span>
							</span>
						</p>
					</div>
				</div>
        <div class="pc-type-pagination" *ngIf="isPC">
          <div class="pc-btn" [ngClass]="{'disabled':item.qstIndex == 1}" (click)="preQA(item.qstIndex)">上一题</div>
          <div class="pc-btn" [ngClass]="{'disabled': item.effectiveOptionsNo == 0 || item.invalidOptionsNo == 0}" (click)="nextQA(item.qstIndex)">
            <span *ngIf="item.qstIndex < qstCount">下一题</span>
            <span *ngIf="item.qstIndex == qstCount">查看结果</span>
          </div>
        </div>
			</div>

			<div class="answer-conver" *ngIf="item.type == 'question'" (click)="showSurQuestionInfo(item)">
				<div class="effectiveOption" (click)="cancelEvent($event)">
					<div class="chktitle">请选择最有效措施</div>
					<div class="option-item" [ngClass]="{'on': subItem.optionsNo == item.effectiveOptionsNo }" *ngFor="let subItem of item.surveySceneOptions;let j=index;" (click)="saveEffectiveItem(item,subItem.optionsNo)">
						{{letterList[j]}}
					</div>
				</div>
				<div class="invalidOption" (click)="cancelEvent($event)">
					<div class="chktitle">请选择最无效措施</div>
					<div class="option-item" [ngClass]="{'on': subItem.optionsNo == item.invalidOptionsNo }" *ngFor="let subItem of item.surveySceneOptions;let j=index;" (click)="saveInvalidItem(item,subItem.optionsNo)">
						{{letterList[j]}}
					</div>
				</div>
			</div>
			<!--<div class="swipTip" *ngIf="item.qstIndex==2 && !item.completeFlag && showSwiptipEable ">-->
				<!--<div class="swipTip-img"></div>-->
				<!--<p class="swipTip-txt">向下滑动可查看上一题哦！</p>-->
				<!--<div class="swipTip-btn" (click)="removeSwipTip()">朕知道了</div>-->
			<!--</div>-->
      <div class="swipTip" *ngIf="item.qstIndex==1 && !item.completeFlag && showSwiptipEable ">
      <!--<div class="swipTip" *ngIf="!item.completeFlag && showSwiptipEable&&(!isSelectedBad||!isSelectedGood) ">-->
        <p class="swipTip-txt">两项都选完才能进入下一题！</p>
        <div class="swipTip-btn" (click)="removeSwipTip()">我知道啦</div>
        <div class="answer">
          <img src="{{assetsRoute}}/picture/experience/arrow-1.png" alt="">
          <img src="{{assetsRoute}}/picture/experience/arrow-2.png" alt="">
        </div>
        <div class="answer">
          <div class="btn-effective">
            <p class="fs36">最有效措施</p>
            <p class="fs28">点击此处选择</p>
          </div>
          <div class="btn-invalid">
            <p class="fs36">最无效措施</p>
            <p class="fs28">点击此处选择</p>
          </div>
        </div>
      </div>
			<div *ngIf="item.type == 'question' && item.qstIndex == qstCount && item.completeFlag && !isPC" class="btn-finish" (click)="saveSurveyInfo(1)">提交</div>
		</li>
	</ul>
	<div class="footer">
		<div *ngIf="!showEnterTxt && showArrowEnable && !isPC" class="icon-arrowUp" [ngClass]="{'dark':enterEnable,'stopanmiate':stopArrowAnimate}"></div>
		<div *ngIf="showEnterTxt&& !isPC" class="enter-text">进入</div>
    <div *ngIf="isPC && showPCBtn && showIntroduce" class="pc-btn" (click)="goNext()">进入{{title}}</div>
	</div>
</div>
<div id="simulationTip" *ngIf="showsceneTipEnable">
	<div class="inner">
		<div [ngClass]=" 'scene scene' + currentSceneTip.sceneId " >
			<div class="sceneInner">
				<div class="sceneSimpleTitle">情景{{currentSceneTip.index+1}}</div>
        <p [innerHtml]="currentSceneTip.sceneTitle"></p>
        <p [innerHtml]="currentSceneTip.sceneDesc"></p>
<!--				<div class="sceneTitle">{{currentSceneTip.sceneTitle}}</div>-->
<!--				<div class="sceneDes" [innerHtml]="currentSceneTip.sceneDesc"></div>-->
			</div>
		</div>
		<div class="closer" (click)="closeSceneDialog()"></div>
	</div>
</div>
<div id="tip1">测验还有 1 分钟了。</div>
<div id="tip2" style="text-align: center">
    <div id="tip2_picture" style="text-align: center">
      <img src="{{assetsRoute}}/picture/feature/clock.svg " style="width: 1.5rem" alt="" />
<!--      <embed src='{{assetsRoute}}/picture/feature/clock.svg' type="image/svg+xml" width="100%" height="100%"/>-->
    </div>
    <p style="position: absolute; left: 50%; transform: translateX(-50%)">到点了，测验结束</p>
</div>
<app-com-tip [type]="'tip'" (onSure)="continueSure()" (onCancel)="continueCancel()" *ngIf="continueTipEnable" [desText]="'之前的测验已完成了<span class=spec>' + surveyBaseInfo.finishQuestionCount +  '</span>题，要继续吗？'" [sureText]="'重新开始'" [cancelText]="'继续测验'"></app-com-tip>
<app-com-tip [type]="'tip'" (onSure)="exitSure()" (onCancel)="exitCancel()" *ngIf="exitTipEnable" [desText]="'何不一鼓作气，做完测验？'" [sureText]="'退出'" [cancelText]="'继续测验'"></app-com-tip>
<app-com-tip [type]="'tip'" *ngIf="!isPreTestFinished && typeId==2 && examId!==0" (onCancel)="goPreSurvey()" [desText]="'请先完成能力诊断，完成后即可解锁能力考核。'" [cancelText]="'立即前往'" [sureText]="''" ></app-com-tip>




// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-leadership-survey/camp-leadership-survey.component.html